import { render, staticRenderFns } from "./JobCategoryPicker.vue?vue&type=template&id=2c823a4c&scoped=true"
import script from "./JobCategoryPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./JobCategoryPicker.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JobCategoryPicker.vue?vue&type=style&index=0&id=2c823a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c823a4c",
  null
  
)

export default component.exports